<template>
    <form class="form" autoComplete="off" :id=formName :name=formName noValidate="" method={method}>
        <fieldset>
            <label for="name2" class="mb-0">Name</label>
            <div class="row mb-1">
                <div class="col-lg-12">
                    <input type="text" name="name2" id="name2" class="form-control" required="" />
                </div>
            </div>
            <label for="email2" class="mb-0">Email</label>
            <div class="row mb-1">
                <div class="col-lg-12">
                    <input type="text" name="email2" id="email2" class="form-control" required="" />
                </div>
            </div>
            <label for="message2" class="mb-0">Message</label>
            <div class="row mb-1">
                <div class="col-lg-12">
                    <textarea rows="6" name="message2" id="message2" class="form-control" required=""></textarea>
                </div>
            </div>
            <button type="submit" class="btn btn-secondary btn-lg float-right">{{ submitBtnText }}</button>
        </fieldset>
    </form>
</template>
<script>
export default {
    props: {
        submitBtnText: {
            type: String,
            default: "Send"            
        }
    }
};
</script>

